module.exports = __webpack_public_path__ + "static/6305-woodrose-55-09ebfc716a5891be6229652c6e788e4a.jpg";